module.exports = __webpack_public_path__ + "fonts/GT-Pressura-Bold.6fedeb4.woff2";